<script setup lang="ts">
import { type SubProgramItem } from '../types/general';
import SearchCard from './SearchCard.vue';

const props = defineProps<{
  results: SubProgramItem[];
  count: number;
}>();
</script>

<template>
  <div class="search-app-results">
    <p
      v-if="props.count"
      class="text-m mt-40 mb-40 fw-500"
    >
      {{ props.count }} <span v-if="props.count === 1">Program</span> <span v-else>Programs</span> Available
    </p>

    <div class="search-app-results__items">
      <SearchCard
        v-for="item in results"
        :key="item.nid"
        :card="item"
      />
    </div>
  </div>
</template>

<style></style>
